import {Button as MuiButton} from '@mui/material';

export const Button = ({
                           text,
                                         icon,
                           className,
                           iconStyle,
                           actionHandler,
                           muiIcon,
                           disabled = false,
                           styleDisable
                       }) => {
    return (
        <MuiButton
            className={className}
            disabled={disabled}
            sx={{
                display: 'flex',
                gap: '15px',
                alignItems: 'center',
                position: 'relative',
                textAlign: 'center',
                borderRadius: '16px',
                "&.Mui-disabled": styleDisable
            }}
            onClick={() => {
                if (!actionHandler) return;
                actionHandler();
            }}
        >
            {icon && <img src={icon} alt="" style={{...iconStyle}}/>}
            {muiIcon && muiIcon}
            {text && <span>{text}</span>}
        </MuiButton>
    );
};
